import * as ActionTypes from '../ActionTypes';


export const GetAttendancePermissionAction = (params, callback) => ({
    type: ActionTypes.GET_ATTENDANCE_PERMISSION_REQUEST,
    params,
    callback
});

export const UpdateAttendancePermissionAction = (params,callback) => ({
    type: ActionTypes.UPDATE_ATTENDANCE_PERMISSION_REQUEST,
    params,
    callback
});
